import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import CloseButton from "./CloseButton/CloseButton";
import MainHeader from "./MainHeader/MainHeader";

const Header = () => {
  return (
    <header className="page-header">
      <div className="logo-wrapper d-flex align-items-center">
        <Link to={`${import.meta.env.BASE_URL}/dashboard`} className="logo w-md-75 order-md-0 order-1">
          <Image className="for-light w-50" src={dynamicImage("logo/tmc_logo_final.png")} alt="logo"/>
          <Image className="for-dark w-50" src={dynamicImage("logo/tmc_logo_final.png")} alt="logo"/>
        </Link> 
        <CloseButton />
      </div>
      <MainHeader />
    </header>
  );
};

export default Header;
